export const LINKS = [{link:'/about',label:'About'},{link:'/',label:'Projects'},{link:'/contact',label:'Contact'}]